import React from "react";
import { useTheme } from "@mui/styles";
import { Typography, useMediaQuery, Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  container: {
    background:
      "linear-gradient(180deg, rgba(246,246,246,1) 83%, rgba(255,255,255,1) 90%)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    borderTopLeftRadius: "9rem",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    color: theme.palette.red.main,
    letterSpacing: { xs: "1.4px", md: "1.6px" },
    fontSize: "0.7rem",
    fontFamily: theme.typography.sourceSansPro.semibold,
  },
  subtitle: {
    color: theme.palette.blue.main,
    fontFamily: theme.typography.montserrat.light,
    fontSize: { xs: "26px", md: "36px", lg: "40px" },
    lineHeight: { xs: "36px", md: "46px", lg: "50px" },
    mt: "15px",
  },
  sliderContainer: {
    width: "100%",
    margin: "3rem 0rem 3rem 0rem",
  },
  line: {
    width: "25px",
    border: `1px solid ${theme.palette.red.main}`,
    marginRight: "8px",
    height: 0,
    backgroundColor: theme.palette.red.main,
  },
  titleContainer: {
    mt: { xs: "70px", md: "90px" },
    display: { md: "flex" },
    justifyContent: { sx: "center", md: "flex-start" },
    alignItems: { md: "center" },
    width: { md: "80vw" },
  },
  mediacontainer: {
    display: "flex",
    flexFLow: "row wrap",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "space-around",
  },
});

const GetToKnowUs = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const { pathname } = useLocation();
  const { title, subtitle, media } = useTranslation(pathname, "GetToKnowUs");

  return (
    <div style={classes.container}>
      <Box sx={classes.titleContainer}>
        {isMobile ? null : <div style={classes.line}></div>}
        <Typography sx={classes.title}>{title}</Typography>
      </Box>
      {isMobile && (
        <Typography sx={classes.subtitle}>
          {subtitle.mobile[0]}
          <span style={{ fontWeight: "bold" }}>{subtitle.mobile[1]}</span>
        </Typography>
      )}

      {!isMobile && (
        <Box sx={{ width: "80vw", display: "flex" }}>
          <Typography sx={classes.subtitle}>
            {subtitle.desktop[0]}
            <span style={{ fontWeight: "bold" }}>{subtitle.desktop[1]}</span>
          </Typography>
        </Box>
      )}

      {isMobile ? (
        <Box
          style={classes.sliderContainer}
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            flexWrap: "wrap",
            width: "100%",
          }}
        >
          {media.map(({ link, img, name }, index) => {
            return (
              <a href={link && link} key={name}>
                <img
                  src={img}
                  alt={index}
                  style={{
                    width: name === "CNN" ? "3rem" : "5rem",
                    objectFit: "contain",
                    margin: "1rem",
                    marginRight: name === "CNN" ? "2rem" : "1rem",
                    marginLeft: name === "CNN" ? "2rem" : "1rem",
                  }}
                />
              </a>
            );
          })}
        </Box>
      ) : (
        <Box sx={classes.mediacontainer}>
          {media.map(({ link, img, name }, index) => {
            return (
              <a href={link && link} key={name}>
                <img
                  src={img}
                  alt={index}
                  key={index}
                  style={{
                    margin: "2rem 0 3rem 0",
                    padding: "1rem",
                    height: "35px",
                  }}
                />
              </a>
            );
          })}
        </Box>
      )}
    </div>
  );
};

export default GetToKnowUs;
